import React from 'react';
import Login from '../Login/Login';
import Logo from '../Logo/Logo';
import Signup from '../Signup/Signup';
import './WelcomePage.css';

const WelcomePage = ({ isSignupVisible, toggleForm }) => {
    return (
        <div className="WelcomePage">
            <div className='CentralDiv'>
                <Logo />
                {isSignupVisible ? (
                    <>
                        <Signup />
                        <button className="ToggleFormButton" onClick={toggleForm}>
                            Já tem uma conta?&nbsp;
                            <span className='BoldText'>
                                Faça login</span>
                        </button>
                    </>
                ) : (
                    <>
                        <Login />
                        <button className="ToggleFormButton" onClick={toggleForm}>
                            Não tem uma conta?&nbsp;
                            <span className='BoldText'>
                                Registre-se
                            </span>
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default WelcomePage;

